import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class AuthGuard {
    private authService: AuthService = inject(AuthService);
    private router: Router = inject(Router);

    public loadGuard(): Observable<boolean> {
        if (this.authService.loggedIn()) {
            return of(true);
        }

        return this.authService.verifyToken().pipe(
            catchError(() => {
                return of(false);
            }),
        );
    }

    public canActivate(): Observable<boolean> {
        return this.loadGuard().pipe(
            map((authenticated) => {
                if (!authenticated) {
                    this.router.navigate(['/admin/auth/login']);
                }
                return authenticated;
            }),
        );
    }
}
